import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router';
import AuthContext from '../../context/Auth/AuthContext';
const PrivateRoute = ({ children, ...rest }) => {
    const { is_login, is_selected_institution, is_firstime } = useContext(AuthContext);

    return (
        <Route
            {...rest}
            render={({ location }) => {
                // this 
                if (is_login()) {
                    if (is_firstime()) {
                        if (rest.path === "/FirstTime") {
                            return children
                        }
                        return <Redirect
                            to={{
                                pathname: "/FirstTime",
                                state: { from: location },
                            }}
                        />
                    } else {
                        if (rest.path === "/FirstTime") {
                            return <Redirect
                                to={{
                                    pathname: "/AuthInstitutions",
                                    state: { from: location },
                                }}
                            />
                        } else {
                            if (!is_selected_institution()) {
                                if (rest.path === "/AuthInstitutions") {
                                    return children
                                }
                                return <Redirect
                                    to={{
                                        pathname: "/AuthInstitutions",
                                        state: { from: location },
                                    }}
                                />
                            } else {
                                return children
                            }
                        }

                    }
                } else {
                    return <Redirect
                        to={{
                            pathname: "/Login",
                            state: { from: location },
                        }}
                    />
                }

            }
            }
        />
    );
};

export default PrivateRoute;
